import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../../providers/UserProvider";
import EeljCountdown from "../eelj/EeljCountdown";
import NewsSlider from "../news/news-slider";
import ServiceSlider from "../service/service-slider";
import FloatingShapes from "../common/FloatingShapes";

const Home = () => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const {eeljuud, userBio, fetchEeljuud} = useContext(UserContext);
  const [curDate, setCurDate] = useState(new Date());

  const stats = [
    { id: 1, name: t('home.statMainShift'), value: "14,900+", icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
      </svg>
    )},
    { id: 2, name: t('home.statDayCamp'), value: "16,000+", icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
      </svg>
    )},
    { id: 3, name: t('home.statTotal'), value: "30,900+", icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" />
      </svg>
    )},
  ];

  const features = [
    {
      title: t('home.featureMainShift'),
      description: t('home.featureMainShiftDesc'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
        </svg>
      ),
      link: isEn ? "/camp-programs" : "/eelj",
      linkText: t('home.featureViewShifts'),
      gradient: "from-primary-500 to-primary-600",
    },
    {
      title: t('home.featureDayCamp'),
      description: t('home.featureDayCampDesc'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
        </svg>
      ),
      link: isEn ? "/facilities" : "/service/67247d8ef4d41faa0c0d0fe3",
      linkText: t('home.featureMore'),
      gradient: "from-secondary-500 to-secondary-600",
    },
    {
      title: t('home.featureProgram'),
      description: t('home.featureProgramDesc'),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342" />
        </svg>
      ),
      link: isEn ? "/camp-programs" : "/program",
      linkText: t('home.featureViewProgram'),
      gradient: "from-accent-500 to-warm-500",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurDate(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchEeljuud();
  }, [fetchEeljuud]);

  return (
    <>
      {/* ===== HERO SECTION - Stripe dark gradient ===== */}
      <div className="relative overflow-hidden bg-primary-800 -mt-20">
        {/* Gradient mesh orbs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute -bottom-20 right-1/3 w-[400px] h-[400px] rounded-full bg-primary-400/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="default" />

        {/* Hero floating shapes */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {/* Large decorative ring - top left */}
          <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full border-2 border-white/[0.04] animate-float" />
          {/* Star burst - right side */}
          <svg className="absolute top-[30%] right-[3%] w-20 h-20 text-primary-300/[0.07] animate-wiggle" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="12,0 14.5,9.5 24,12 14.5,14.5 12,24 9.5,14.5 0,12 9.5,9.5" />
          </svg>
          {/* Cross/Plus - left */}
          <svg className="absolute top-[55%] left-[3%] w-10 h-10 text-white/[0.06] animate-bounce-slow" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "2s" }}>
            <rect x="10" y="2" width="4" height="20" />
            <rect x="2" y="10" width="20" height="4" />
          </svg>
          {/* Dotted circle */}
          <div className="absolute bottom-[25%] right-[15%] w-24 h-24 rounded-full border-2 border-dashed border-white/[0.04] animate-wiggle" style={{ animationDelay: "3s" }} />
          {/* Small filled circles scattered */}
          <div className="absolute top-[20%] left-[15%] w-3 h-3 rounded-full bg-secondary-400/[0.12] animate-bounce-slow" style={{ animationDelay: "1s" }} />
          <div className="absolute top-[40%] right-[25%] w-2 h-2 rounded-full bg-primary-300/[0.15] animate-float" style={{ animationDelay: "4s" }} />
          <div className="absolute bottom-[35%] left-[40%] w-2.5 h-2.5 rounded-full bg-white/[0.08] animate-bounce-slow" style={{ animationDelay: "2.5s" }} />
          <div className="absolute top-[15%] right-[40%] w-2 h-2 rounded-full bg-secondary-300/[0.10] animate-float" style={{ animationDelay: "5s" }} />
          {/* Pentagon */}
          <svg className="absolute bottom-[15%] left-[10%] w-12 h-12 text-white/[0.04] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "1.5s" }}>
            <polygon points="12,2 22,9 19,20 5,20 2,9" />
          </svg>
          {/* Large semi-transparent hexagon */}
          <svg className="absolute top-[10%] right-[20%] w-28 h-28 text-primary-400/[0.03] animate-float" viewBox="0 0 24 24" fill="currentColor" style={{ animationDelay: "3.5s" }}>
            <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />
          </svg>
        </div>

        {/* Grid pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />

        <div className="relative pt-40 pb-20 sm:pt-48 sm:pb-28 lg:pt-56 lg:pb-36">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
              {/* Badge */}
              <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-primary-300 backdrop-blur-sm">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
                {t('home.badge')}
              </div>

              <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.1]">
                <span className="bg-gradient-to-r from-primary-400 via-secondary-400 to-primary-300 bg-clip-text text-transparent">
                  {t('home.nairamdal')}
                </span>
              </h1>

              {isEn || eeljuud.activeEelj.length === 0 ? (
                <p className="mt-8 text-lg sm:text-xl text-slate-400 leading-relaxed max-w-2xl mx-auto">
                  {t('home.heroDescription')}
                </p>
              ) : (
                <div className="mt-10">
                  <EeljCountdown {...eeljuud.activeEelj[0]} dark/>
                </div>
              )}

              <div className="mt-12 flex flex-wrap gap-4 items-center justify-center">
                {isEn ? (
                  <>
                    <Link to="/camp-programs">
                      <button className="group inline-flex items-center gap-2 rounded-full bg-white px-8 py-3.5 text-[15px] font-semibold text-primary-800 hover:bg-slate-100 transition-colors">
                        Camp Programs
                        <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                      </button>
                    </Link>
                    <Link to="/about">
                      <button className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-8 py-3.5 text-[15px] font-semibold text-white hover:bg-white/10 backdrop-blur-sm transition-colors">
                        About Us
                      </button>
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to="/eelj">
                      <button className="group inline-flex items-center gap-2 rounded-full bg-white px-8 py-3.5 text-[15px] font-semibold text-primary-800 hover:bg-slate-100 transition-colors">
                        {t('home.viewShifts')}
                        <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                      </button>
                    </Link>

                    {!userBio ? (
                      <Link to="/register">
                        <button className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-8 py-3.5 text-[15px] font-semibold text-white hover:bg-white/10 backdrop-blur-sm transition-colors">
                          {t('home.register')}
                        </button>
                      </Link>
                    ) : (
                      eeljuud.activeEelj.length > 0 && new Date(eeljuud.activeEelj[0].orderStartDate) < curDate && (
                        <Link to={`/payment/${eeljuud.activeEelj[0].id}`}>
                          <button className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500 px-8 py-3.5 text-[15px] font-semibold text-white hover:opacity-90 transition-opacity">
                            {t('home.order')}
                          </button>
                        </Link>
                      )
                    )}
                  </>
                )}
              </div>
            </div>

            {/* Hero image with glow */}
            <div className="mt-20 sm:mt-24 relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-secondary-500/20 to-primary-500/20 rounded-3xl blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                <img
                  src="/hero1.jpeg"
                  alt={t('common.nairamdal')}
                  width={2432}
                  height={1442}
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== STATS SECTION - Stripe counter style ===== */}
      <div className="relative bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-neutral-900 tracking-tight">
              {t('home.statsTitle')}
            </h2>
            <p className="mt-4 text-lg text-neutral-500">
              {t('home.statsDescription')}
            </p>
          </div>
          <dl className="grid grid-cols-1 gap-6 sm:grid-cols-3">
            {stats.map((stat) => (
              <div
                key={stat.id}
                className="group relative rounded-2xl border border-neutral-200/80 p-8 text-center hover:border-primary-200 hover:shadow-lg transition-all duration-300"
              >
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-primary-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary-50 text-primary-600 mb-4">
                    {stat.icon}
                  </div>
                  <dd className="text-4xl sm:text-5xl font-extrabold tracking-tight bg-gradient-to-r from-primary-600 to-secondary-500 bg-clip-text text-transparent">
                    {stat.value}
                  </dd>
                  <dt className="mt-2 text-sm font-medium text-neutral-500 uppercase tracking-wider">
                    {stat.name}
                  </dt>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>

      {/* ===== FEATURES GRID - Stripe product cards ===== */}
      <div className="relative bg-primary-800 py-20 sm:py-28">
        {/* Background orbs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-0 left-1/4 w-[400px] h-[400px] rounded-full bg-primary-600/10 blur-[100px]" />
          <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] rounded-full bg-secondary-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="sparse" />

        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
              {t('home.featuresTitle')}
            </h2>
            <p className="mt-4 text-lg text-slate-400">
              {t('home.featuresDescription')}
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            {features.map((feature) => (
              <Link
                key={feature.title}
                to={feature.link}
                className="group relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-8 hover:bg-white/[0.08] hover:border-white/20 transition-all duration-300"
              >
                {/* Gradient top accent */}
                <div className={`absolute top-0 left-8 right-8 h-px bg-gradient-to-r ${feature.gradient} opacity-0 group-hover:opacity-100 transition-opacity`} />

                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br ${feature.gradient} text-white mb-6`}>
                  {feature.icon}
                </div>

                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-slate-400 leading-relaxed mb-6">{feature.description}</p>

                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-400 group-hover:text-primary-300 transition-colors">
                  {feature.linkText}
                  <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* ===== MAIN SHIFT - Immersive dark split ===== */}
      <div className="relative overflow-hidden bg-primary-800 py-24 sm:py-32">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-1/2 -translate-y-1/2 -right-20 w-[500px] h-[500px] rounded-full bg-primary-600/15 blur-[120px]" />
          <div className="absolute top-0 left-1/4 w-[300px] h-[300px] rounded-full bg-primary-400/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="alt" />
        <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />

        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm font-semibold text-primary-300 backdrop-blur-sm mb-6">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                </svg>
                {t('home.mainShiftBadge')}
              </div>
              <h2 className="text-3xl sm:text-[42px] font-extrabold text-white tracking-tight leading-[1.15]">
                {t('home.mainShiftTitle')}{" "}
                <span className="bg-gradient-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent">
                  {t('home.mainShiftTitleHighlight')}
                </span>
              </h2>
              <p className="mt-6 text-lg text-slate-400 leading-relaxed">
                {t('home.mainShiftDescription')}
              </p>

              {/* Mini stats */}
              <div className="mt-8 grid grid-cols-3 gap-4">
                <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-4 text-center">
                  <p className="text-2xl font-extrabold bg-gradient-to-r from-primary-400 to-primary-300 bg-clip-text text-transparent">40+</p>
                  <p className="text-xs text-slate-500 mt-1">{t('home.shiftsPerYear')}</p>
                </div>
                <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-4 text-center">
                  <p className="text-2xl font-extrabold bg-gradient-to-r from-secondary-400 to-secondary-300 bg-clip-text text-transparent">3-10</p>
                  <p className="text-xs text-slate-500 mt-1">{t('home.days')}</p>
                </div>
                <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-4 text-center">
                  <p className="text-2xl font-extrabold bg-gradient-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent">4</p>
                  <p className="text-xs text-slate-500 mt-1">{t('home.seasons')}</p>
                </div>
              </div>

              <div className="mt-8 flex items-center gap-4">
                <Link to={isEn ? "/camp-programs" : "/eelj"}>
                  <button className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3 text-[15px] font-semibold text-primary-800 hover:bg-slate-100 transition-colors">
                    {t('home.viewShiftsBtn')}
                    <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                  </button>
                </Link>
                <Link to="/about" className="text-sm font-semibold text-primary-400 hover:text-primary-300 transition-colors">
                  {t('home.aboutUs')}
                </Link>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-tr from-primary-500/20 via-secondary-500/10 to-primary-500/20 rounded-3xl blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                <img
                  src="/undsen_eelj.jpeg"
                  width={1200}
                  height={600}
                  alt="Үндсэн ээлж"
                  className="w-full h-auto object-cover"
                />
                {/* Gradient overlay on image */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary-800/40 via-transparent to-transparent" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== DAY CAMP - Bright white with vivid accents ===== */}
      <div className="relative bg-white py-24 sm:py-32 overflow-hidden">
        {/* Decorative blobs */}
        <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-secondary-100/50 blur-[100px]" />
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] rounded-full bg-primary-100/40 blur-[80px]" />

        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="lg:order-2">
              <div className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-secondary-50 to-accent-50 px-4 py-1.5 text-sm font-semibold text-secondary-700 mb-6 ring-1 ring-secondary-200/50">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                </svg>
                {t('home.dayCampBadge')}
              </div>
              <h2 className="text-3xl sm:text-[42px] font-extrabold text-neutral-900 tracking-tight leading-[1.15]">
                {t('home.dayCampTitle')}{" "}
                <span className="bg-gradient-to-r from-secondary-600 to-accent-500 bg-clip-text text-transparent">
                  {t('home.dayCampTitleHighlight')}
                </span>
              </h2>
              <p className="mt-6 text-lg text-neutral-500 leading-relaxed">
                {t('home.dayCampDescription')}
              </p>

              {/* Feature list */}
              <div className="mt-8 space-y-4">
                {[
                  { text: t('home.dayCampFeature1'), color: "text-secondary-600 bg-secondary-50" },
                  { text: t('home.dayCampFeature2'), color: "text-primary-600 bg-primary-50" },
                  { text: t('home.dayCampFeature3'), color: "text-accent-600 bg-accent-50" },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3">
                    <div className={`flex-shrink-0 w-8 h-8 rounded-lg ${item.color} flex items-center justify-center`}>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    </div>
                    <span className="text-neutral-700 font-medium">{item.text}</span>
                  </div>
                ))}
              </div>

              <div className="mt-8">
                <Link to={isEn ? "/facilities" : "/service/67247d8ef4d41faa0c0d0fe3"}>
                  <button className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-secondary-600 to-secondary-500 px-7 py-3 text-[15px] font-semibold text-white hover:opacity-90 transition-opacity shadow-lg shadow-secondary-500/25">
                    {t('home.dayCampMore')}
                    <svg className="w-4 h-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                  </button>
                </Link>
              </div>
            </div>

            <div className="lg:order-1 relative">
              <div className="absolute -inset-4 bg-gradient-to-tr from-secondary-200/60 via-accent-100/40 to-secondary-200/60 rounded-3xl blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/5">
                <img
                  src="/Busad-hutulbur-1.jpg"
                  width={1200}
                  height={600}
                  alt="Өдрийн амралт"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-4 -right-4 sm:bottom-6 sm:right-6 bg-white rounded-2xl shadow-xl p-4 border border-neutral-100">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-secondary-500 to-secondary-600 flex items-center justify-center text-white">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-bold text-neutral-900">16,000+</p>
                    <p className="text-xs text-neutral-500">{t('home.dayCampers')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== SERVICES - Dark with gradient cards ===== */}
      {!isEn && (
        <div className="relative overflow-hidden bg-primary-800">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-primary-600/15 blur-[120px]" />
            <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[100px]" />
          </div>
          <FloatingShapes variant="default" />
          <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
          <div className="relative">
            <ServiceSlider dark />
          </div>
        </div>
      )}

      {/* ===== NEWS - Light with accents ===== */}
      <div className="relative bg-white overflow-hidden">
        <div className="absolute top-0 left-1/3 w-[400px] h-[400px] rounded-full bg-primary-50/80 blur-[100px]" />
        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-secondary-50/60 blur-[80px]" />
        <div className="relative">
          <NewsSlider />
        </div>
      </div>
    </>
  );
};

export default Home;
